import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LogoUrl from './../../assets/img/logo_negative.svg';
import SmartLink from "../../lib/includes/components/component.smartlink";

const Footer = (props) => {
	if (!props.general) return null;

	const footer = props.general.footer;
	const footerNav = props.menu?.menus?.footer_nav;
	const footerMenu = props.menu?.menus?.footer_menu;

	return <footer className="site-footer">

		{/* Övre raden: logo + nav + knapp */}
		<div className="container">
		<div className="footer-top">
				<div className="footer-top-inner">

					<Link to="/" className="footer-logo">
						<img src={LogoUrl} alt={props.general.title} />
					</Link>

					{footerNav &&
						<ul className="footer-nav">
							{footerNav.items.filter(i => i.parent === 0).map((item, i) => (
								<li key={i}>
									<SmartLink url={item.url} target={item.target}>
										{item.title}
									</SmartLink>
								</li>
							))}
						</ul>
					}

					{footer?.footer_btn &&
						<SmartLink
							url={footer.footer_btn.url}
							target={footer.footer_btn.target}
							className="button button-primary button-sm footer-btn"
						>
							{footer.footer_btn.title}
						</SmartLink>
					}

				</div>
			</div>
		</div>

		{/* Undre raden: kontaktinfo + footer-menu */}
		<div className="container">
		<div className="footer-bottom">
				<div className="footer-bottom-inner">

					<div className="footer-contact">
						{footer?.address && <span>{footer.address}</span>}
						{(footer?.postal_code || footer?.city) &&
							<span>{[footer.postal_code, footer.city].filter(Boolean).join(', ')}</span>
						}
						{footer?.phone && <span><a href={"tel:" + footer.phone}>{footer.phone}</a></span>}
						{footer?.email && <span><a href={"mailto:" + footer.email}>{footer.email}</a></span>}
					</div>

					{footerMenu &&
						<ul className="footer-menu">
							{footerMenu.items.filter(i => i.parent === 0).map((item, i) => (
								<li key={i}>
									<SmartLink url={item.url} target={item.target}>
										{item.title}
									</SmartLink>
								</li>
							))}
						</ul>
					}

				</div>
			</div>
		</div>

		{/* Logotyper / Partners */}
		{footer?.logotypes && footer.logotypes.length > 0 &&
			<div className="footer-logotypes">
				<div className="container">
					<div className="footer-logotypes-inner">
						{footer.logotypes.map((item, i) => (
							<div key={i} className="footer-logotype-item">
								{item.logo && <img src={item.logo.url} alt={item.logo.alt || ''} />}
							</div>
						))}
					</div>
				</div>
			</div>
		}

	</footer>
};

export default connect(
	state => ({
		general: state.generalState.general,
		menu: state.menuState
	})
)(Footer);